import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/internal/Observable';
import { catchError } from 'rxjs/internal/operators/catchError';
import { CommonService } from 'src/app/shared/services/common-service';
import { environment } from 'src/environments/environment';
import { UBSCreatePatientRequest } from '../../requests/orchestrator-integration/ubs-create-patient.request';
import { UBSSearchResponse } from '../../responses/orchestrator-integration/ubs-search.response';
import { WebhookStruct } from '../../structs/Integration/webhook-struct';

@Injectable({
  providedIn: 'root'
})
export class UBSWebhookService extends CommonService {

  constructor(private router: Router, private httpClient: HttpClient) {
    super();
  }

  public createPatient(body: UBSCreatePatientRequest, webhookStruct: WebhookStruct): Observable<UBSSearchResponse> {

    let uri = `api/v1/Webhook/uBSCreatePatient`;

    body.url = webhookStruct.url;
    body.token = webhookStruct.token;

    return this.httpClient.post<UBSSearchResponse>(environment.urlApiOrchestratorIntegration + uri, body, this.addHeaderKey(webhookStruct.guid))
      .pipe(
        catchError(this.handleError)
      )
  }
}